<template>
  <div>
    <div 
      :class="{
        'toggle-tab-v2': true,
        'toggle-tab-fixed': fixed && isScreenCaptureShow
      }"
    >
      <div style="width: 100%; display: flex">
        <template v-if="kind">
          <div
            data-stat-id="zrgl"
            :class="`tab-item ${kind === 1 ? 'tab-item-active' : ''}`"
            @click.stop="toggle(0); toggleKind(1)"
          >
            <span class="tab-span-first">概览</span>
            概览
          </div>
          <div data-stat-id="zraxz" :class="`tab-item ${showType === 1 && kind !== 1 ? 'tab-item-active' : ''}`" @click.stop="toggle(1); toggleKind(2)">
            <span class="tab-span">按险种</span>
            按险种
          </div>
          <div
            data-stat-id="zrazr"
            :class="`tab-item ${showType === 0 && kind !== 1 ? 'tab-item-active' : ''}`"
            @click.stop="toggle(0); toggleKind(2)"
          >
            <span class="tab-span-last">按责任</span>
            按责任
          </div>
        </template>
        <template v-else>
          <div
            data-stat-id="zraxz"
            :class="`tab-item ${showType === 1 ? 'tab-item-active' : ''}`"
            :style="`
                ${showType === 0 ? 'margin-right: -3px;' : ''}
              `"
            @click.stop="toggle(1)"
          >
            <span class="tab-span-first">按险种</span>
            按险种
          </div>
          <div
            data-stat-id="zrazr"
            :class="`tab-item ${showType === 0 ? 'tab-item-active' : ''}`"
            :style="`
                ${showType === 1 ? 'margin-left: -3px;' : ''}
              `"
            @click.stop="toggle(0)"
          >
            <span class="tab-span-last">按责任</span>
            按责任
          </div>
        </template>
      </div>
    </div>

    <!--计划书2.0 兼容险种切换悬浮时页面高度-->
    <div v-if="fixed && isScreenCaptureShow" style="height: 24px" />
  </div>
</template>
  
  <script>
  export default {
    props: {
      isScreenCaptureShow: {
        type: Boolean,
        default: false
      },
      showType: {
        type: Number,
        default: 0
      },
      kind: {
        type: Number,
        default: 0
      },
      fixed: Boolean
    },
    data () {
      return {
        currentIndex: this.showType
      }
    },
    methods: {
      toggle (showType) {
        if (this.showType === showType) return
        this.$emit('toggle', showType)
      },
      toggleKind (kind) {
        if (this.kind === kind) return
        this.$emit('toggle-kind', kind)
      }
    }
  }
  </script>
  
  <style lang="postcss">
  @import 'variable.css';
  
  .toggle-tab-v2 {
    display: inline-block;
    border-radius: 24px;;
    transform: translate(-50%, 1.06rem);
    font-size: 13px;
    box-sizing: border-box;
    margin-left: 50%;
    text-align: center;
    position: relative;
    color: var(--theme-primary-color);
    background: var(--theme-patch-bg);
    border: 1px solid var(--theme-border-color);
    z-index: 12;
    .tab-item {
      margin: 0;
      display: inline-block;
      padding: 4px 12px;
      position: relative;
      span {
        display: none;
      }
    }
    .tab-item-active {
      color: #fff;
      position: relative;
      font-weight: bold;
      border-radius: 50px;
      background: var(--theme-primary-color);
      span {
        position: absolute;
        left: -1px;
        top: -1px;
        padding-top: 0.1rem;
        display: block;
        bottom: -1px;
        right: -1px;
        z-index: 14;
        border-radius: 24px
      }
    }
  }
  .toggle-tab-fixed {
    width: 100%!important;
    background: #fff!important;
    border-top: none!important;
    border-left: none!important;
    border-right: none!important;
    border-bottom: #e5e5e5 1px solid!important;
    height: 44px;
    z-index: 100;
    line-height: 44px;
    position: fixed;
    left: 0;
    top: 0;
    margin-left: 0;
    display: flex;
    transform: translate(0, 0);
    border-radius: 0;
    .tab-item {
      flex: 1;
      color: #333;
      padding: 0;
    }
    .tab-item-active {
      background: none!important;
      position: relative;
      color: var(--theme-primary-color);
      span {
        display: none;
      }
      &:after {
        content: '';
        display: block;
        width: 22px;
        height: 4px;
        border-radius: 10px;
        position: absolute;
        left: 50%;
        top: 100%;
        transform: translate(-50%, -100%);
        background: var(--theme-primary-color);
      }
    }
  }
  </style>